module.exports = __webpack_public_path__ + "img/mark.7fe02f7c.png";